export default __webpack_public_path__ + "static/media/upload.3c47e739.svg";